// import Popup from 'react-popup'
import { detect } from 'detect-browser'

import moment from 'moment'
import './polyfills'

import FICModal from '../../components/js/FICModal'
import FICModalV2 from '../../../common/components-v2/FICModal/FICModal'
import FICAlert from '../../components/js/FICAlert'
import FICForm from '../../../common/forms-v2/FICForm/FICForm'
import { config } from '../../../common/forms-v2/config'
import MixPanelTracker from './MixPanelTracker'
import HotjarTracker from './HotjarTracker'
import TagManagerTracker from './TagManagerTracker'

// import '../css/Popup.css'

class FIC {

}

FIC.init = () => {
  // ReactDOM.render(<Popup />, overlayContainer)
  FIC.globals = reactGlobalParams
  FIC.browser = detect()
  FICModal.init(document.getElementById('react-overlay-modal-container'))
  FICModalV2.init(document.getElementById('react-overlay-modal2-container'))
  FICAlert.init(document.getElementById('react-overlay-alert-container'))
  FICForm.init(FICForm.createConfig(config))
  moment.locale('it')
  window.FICAlert = FICAlert
}

FIC.can = (accessLevel, moduleName, submoduleName = '') => {
  const permissions = FIC.globals.permissions
  let p
  if (![ 'read', 'write' ].includes(accessLevel)) {
    return false
  }
  if (!permissions || !permissions.hasOwnProperty(moduleName)) {
    return false
  }
  if (permissions[ moduleName ] === 'detailed') {
    if (!permissions[ moduleName + '_detailed' ].hasOwnProperty(submoduleName)) {
      return false
    }
    p = permissions[ moduleName + '_detailed' ][ submoduleName ]
  } else {
    p = permissions[ moduleName ]
  }
  if (p === 'none') {
    return false
  }
  if (accessLevel === 'read') {
    return true
  }
  return p === 'write'
}

FIC.canRead = (moduleName, submoduleName = '') => {
  return FIC.can('read', moduleName, submoduleName)
}

FIC.canWrite = (moduleName, submoduleName = '') => {
  return FIC.can('write', moduleName, submoduleName)
}

FIC.tracker = new MixPanelTracker()
FIC.tracker.setConfig({
  debug: false
})

FIC.hj = new HotjarTracker()

FIC.gtm = new TagManagerTracker()

export default FIC



// WEBPACK FOOTER //
// ./src/common/general/js/FIC.js